import { useState } from 'react';
import { faqList } from '@/mocks/manhwa';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-5">
          <span className="inline-block px-4 py-1.5 rounded-full border border-secondary-300 text-secondary-600 text-sm mb-4 whitespace-nowrap">
            常见问题
          </span>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-4">
            你想知道的都在这里
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            关于韩漫星球的常见问题解答
          </p>
        </div>

        <div className="space-y-3">
          {faqList.slice(0, 6).map((faq, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-lg overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-background-200/70 transition-colors"
                onClick={() => toggleFAQ(index)}
              >
                <h4 className="text-sm font-semibold text-foreground-950 pr-4">
                  {faq.question}
                </h4>
                <i
                  className={`ri-arrow-down-s-line text-foreground-500 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}